import { edmCampaign } from '@bingads-webui/edm-campaign';

export const loadAds = ({
  cid,
  aid,
  campaignId,
  adGroupId,
  filter = {},
  count = 1,
}) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AdGroups.$withKey(adGroupId)
    .Ads['Default.GridData']
    .$makeCall({
      query: {
        top: count,
        count: true,
        orderby: { Id: 1 },
        filter,
        select: [
          'Id',
          'Type',
          'Text',
          'TextPart2',
          'FinalUrls',
          'FinalUrlSuffix',
          'MobileFinalUrls',
          'DisplayUrl',
          'Path1',
          'Path2',
          'TrackingUrlTemplate',
          'UrlCustomParameters',
          'Model.ResponsiveAd/BusinessName',
          'Model.ResponsiveAd/CallToAction',
          'Model.ResponsiveAd/CallToActionLanguage',
          'Model.ResponsiveAd/Headline',
          'Model.ResponsiveAd/LongHeadline',
          'Model.ResponsiveAd/Descriptions',
          'Model.ResponsiveAd/Headlines',
          'Model.ResponsiveAd/Images',
          'Model.ResponsiveAd/ImpressionTrackingUrls',
          'Model.ResponsiveAd/LandscapeImageMediaId',
          'Model.ResponsiveAd/LandscapeImageMediaUrl',
          'Model.ResponsiveAd/LandscapeLogoMediaId',
          'Model.ResponsiveAd/LandscapeLogoMediaUrl',
          'Model.ResponsiveAd/LongHeadlines',
          'Model.ResponsiveAd/SquareImageMediaId',
          'Model.ResponsiveAd/SquareImageMediaUrl',
          'Model.ResponsiveAd/SquareLogoMediaId',
          'Model.ResponsiveAd/SquareLogoMediaUrl',
          'Model.ResponsiveAd/VerifiedTrackingSettings',
          'Model.ResponsiveSearchAd/Descriptions',
          'Model.ResponsiveSearchAd/Headlines',
        ],
      },
      payload: {
        gridDataParameters: {},
      },
    })
    .toPromise()
    .then((response) => {
      const { value } = response;
      return value;
    });
